<template>
  <v-container>
    <v-dialog v-model="show_dialog_box" max-width="800px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class="font-weight-bold text-capitalize" color="primary">
          View More
        </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Switch History</span>
          <v-spacer></v-spacer>
          <v-btn text color="dark" @click="show_dialog_box = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Additional Days</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">
                {{ history.additionalDays ? history.additionalDays : 0 }}
              </h4>
            </v-flex>
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Additional Price</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">{{ history.additionalPrice ? history.additionalPrice : 0 }} KWD</h4>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mt-2">
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Discount</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">{{ history.discount ? history.discount : 0 }} KWD</h4>
            </v-flex>
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Net Payable</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">{{ history.netPayable ? history.netPayable : 0 }} KWD</h4>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mt-2">
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Payment Method</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">
                {{ history.paymentMethod }}
              </h4>
            </v-flex>
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Updated By</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text" v-if="history.updatedBy">
                {{ history.updatedBy.firstnameEn }}
                {{ history.updatedBy.lastnameEn }}
              </h4>
            </v-flex>
          </v-layout>

          <v-layout wrap class="mt-2">
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">From Package</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">
                {{ history.from.packageTitleEn }}
              </h4>
            </v-flex>
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">To Package</h4>
            </v-flex>
            <v-flex xs12 sm8 md3>
              <h4 class="text-body-2 dark--text">
                {{ history.to.packageTitleEn }}
              </h4>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mt-2">
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Status</h4>
            </v-flex>
            <v-flex xs12 sm8 md10>
              <h4 class="text-body-2 dark--text">
                {{ history.status }}
              </h4>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mt-2" v-if="history.invoiceUrl">
            <v-flex xs12 sm4 md2 class="">
              <h4 class="text-body-2 dark--text">Invoice Url</h4>
            </v-flex>
            <v-flex xs12 sm8 md10>
              <h4 class="text-body-2 dark--text">
                <a :href="history.invoiceUrl" target="_blank"> {{ history.invoiceUrl }}</a>
              </h4>
            </v-flex>
          </v-layout>
          <v-layout wrap class="mt-2">
            <v-flex xs12 sm8 md10>
              <MarkAsPaidPlanSwitch :history="history" v-if="history.status == 'PENDING'" />
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import MarkAsPaidPlanSwitch from "./MarkAsPaidPlanSwitch.vue";
export default {
  components: { MarkAsPaidPlanSwitch },
  methods: {},
  props: {
    history: {
      require: true,
    },
  },

  mounted() {
    this.$root.$on("closePlanSwitchWindows", () => {
      this.loading = true;
      this.show_dialog_box = false;
    });
  },

  data: () => ({
    loading: true,
    show_dialog_box: false,
  }),
};
</script>
